import styled from 'styled-components'

import { helpers } from 'styles'

import Nordea from './nordea.svg'

type Props = {
	size?: number
}

export const Logo = styled.img.attrs<Props>(() => ({
	src: Nordea,
	alt: 'Nordea logo',
}))<Props>`
	width: ${({ size = 86 }) => size}px;
	fill: ${helpers.color.textContrast};
`
